import { ListItem, styled } from '@mui/material';

export const Root = styled(ListItem)(({ theme }) => ({
  padding: 0,
}));
